export enum PAGE_VIEW_EVENTS {
    brand = 'brand_lp_page_view',
    product = 'product_lp_page_view',
}
